import ChevronIcon from "assets/icons/ChevronIcon";

export interface SortProps {
  onSort: (dir: "asc" | "desc") => void;
}
export default function Sort(props: SortProps) {
  return (
    <div className="flex flex-col justify-center items-center relative">
      <div className="-mb-[2px] cursor-pointer" onClick={() => props.onSort("asc")}>
        <ChevronIcon rotate="top" scale={0.5} />
      </div>
      <div className="-mt-[2px] cursor-pointer" onClick={() => props.onSort("desc")}>
        <ChevronIcon scale={0.5} />
      </div>
    </div>
  );
}
